import React, { ReactElement } from 'react';
import Svg, { G, Path } from 'react-native-svg';

import { IconStyles } from 'components/icons/types';

/**
 * Books that are used to represent the Practice Library
 * @param size: the size of the square where the icon lives
 * @param style: the IconStyle of the icon
 */
export const PracticeLibraryIcon = ({
  size,
  style,
}: {
  size: number;
  style?: IconStyles;
}): ReactElement => {
  return (
    <Svg
      width={`${size}px`}
      height={`${size}px`}
      viewBox="0 0 40 40"
      style={style}
    >
      <G fill="none" fillRule="evenodd">
        <G>
          <Path d="M0 0H40V40H0z" />
          <G fill={style?.color || 'currentColor'}>
            <G>
              <Path d="M9 14L9 30C9 30.5523 9.44772 31 10 31L13 31C13.5523 31 14 30.5523 14 30L14 14C14 13.4477 13.5523 13 13 13L10 13C9.44772 13 9 13.4477 9 14Z" />
              <Path d="M17 9L17 30C17 30.5523 17.4477 31 18 31L21 31C21.5523 31 22 30.5523 22 30L22 9C22 8.44772 21.5523 8 21 8L18 8C17.4477 8 17 8.44772 17 9Z" />
              <Path
                d="M26 12L26 30C26 30.5523 26.4477 31 27 31L30 31C30.5523 31 31 30.5523 31 30L31 12C31 11.4477 30.5523 11 30 11L27 11C26.4477 11 26 11.4477 26 12Z"
                transform="rotate(-15 28.5 21)"
              />
            </G>
          </G>
        </G>
      </G>
    </Svg>
  );
};
